import addService from "app/api/requests/Services/addServiceRequest";
import delService from "app/api/requests/Services/delServiceRequest";
import editService from "app/api/requests/Services/editServiceRequest";
import getServices from "app/api/requests/Services/getServicesRequest";

export default {
  addService,
  delService,
  editService,
  getServices
};
